/* ============================================================================
   Barnaby Bars — themed gifting ad configs.

   These land on the build-a-box / gifting page via ?ad=<key> and drive:
     • headline   — the page title (from the ad)
     • subtitle   — the page subtitle (written by Barney)
     • flavour    — leads the box prefill
     • type       — 'date' | 'name' | 'story'  → pre-selects that personaliser
     • bars       — the ad's own content → becomes the personaliser placeholders
     • theme      — a key in personaliser-themes.js → drives EVERY "Need inspiration"
                    set (name · date · story) to that theme
     • pronoun    — 'her' | 'his' | 'their' → genders the box copy
                    ("Choose your box" → "Choose her box"). Omit for the default "your".
     • headline   — also renders in the Utile Display font on the ad landing page

   Phase 3 (the Bar Ads dashboard) will generate entries in this shape. The three
   below are examples you can test now — visit e.g.
     /pages/gifting?ad=example-anniversary-date
   ========================================================================== */
(function () {
  window.adConfigs = window.adConfigs || {};

  window.adConfigs['example-anniversary-date'] = {
    headline: 'Turn your anniversary into chocolate',
    subtitle: 'Six handmade bars, printed with your story',
    flavour: 'Caramel',
    type: 'date',
    theme: 'anniversary',
    pronoun: 'her',
    bars: [
      { top: '07.04.19', message: 'The day we met' },
      { top: '09.08.21', message: 'Moved in together' },
      { top: '14.02.22', message: 'Our first Valentine’s' },
      { top: '25.12.22', message: 'First Christmas' },
      { top: '18.06.23', message: 'The proposal' },
      { top: '05.09.24', message: 'Our wedding day' },
    ],
  };

  window.adConfigs['example-birthday-name'] = {
    headline: 'A birthday gift with their name on it',
    subtitle: 'Handmade bars, personalised just for them',
    flavour: 'Hazelnut',
    type: 'name',
    theme: 'birthday',
    bars: [
      { top: 'Sarah', message: 'Happy 30th!' },
      { top: 'Sarah', message: 'Make a wish' },
    ],
  };

  window.adConfigs['example-friendship-story'] = {
    headline: 'Tell your friendship story in chocolate',
    subtitle: 'Every bar a chapter of your story',
    flavour: 'Raspberry',
    type: 'story',
    theme: 'friendship',
    bars: [
      { top: 'Chapter 1', message: 'The day we met' },
      { top: 'Chapter 2', message: 'First adventure' },
      { top: 'Chapter 3', message: 'Through thick & thin' },
      { top: 'Chapter 4', message: 'Big laughs' },
      { top: 'Chapter 5', message: 'Always there' },
      { top: 'Chapter 6', message: 'Best friends' },
    ],
  };

  window.adConfigs['i-hid-six-birthday-memories-inside-a-box'] = {
    headline: 'I hid six birthday memories inside a box of chocolate.',
    subtitle: 'Create six personalised chocolate bars that tell your story, one memory at a time.',
    flavour: 'Caramel',
    type: 'date',
    theme: 'birthday',
    pronoun: 'their',
    bars: [
      { top: '07.04.19', message: 'The day we met' },
      { top: '12.08.20', message: 'First holiday together' },
      { top: '18.07.21', message: 'That spontaneous road trip' },
      { top: '09.10.22', message: 'The proposal' },
      { top: '15.06.24', message: 'The best year yet' },
      { top: '14.06.26', message: 'Happy Birthday' },
    ],
  };

  window.adConfigs['six-memories-one-unforgettable-birthday'] = {
    headline: 'Six memories. One unforgettable birthday.',
    subtitle: 'Create six personalised chocolate bars that tell your story, one memory at a time.',
    flavour: 'Caramel',
    type: 'date',
    theme: 'birthday',
    pronoun: 'their',
    bars: [
      { top: '07.04.19', message: 'The day we met' },
      { top: '12.08.20', message: 'First holiday together' },
      { top: '18.07.21', message: 'That spontaneous road trip' },
      { top: '09.10.22', message: 'The proposal' },
      { top: '15.06.24', message: 'The best year yet' },
      { top: '14.06.26', message: 'Happy Birthday' },
    ],
  };

  window.adConfigs['six-bars-br-one-impossible-question'] = {
    headline: 'Six bars. <br>One impossible question.',
    subtitle: 'Create six personalised chocolate bars <br> that build up to the perfect surprise.',
    flavour: 'Caramel',
    type: 'name',
    theme: 'just-because',
    pronoun: 'their',
    bars: [
      { top: 'Kate', message: "We've talked." },
      { top: 'Kate', message: "We've debated." },
      { top: 'Kate', message: "We've researched." },
      { top: 'Kate', message: "We've promised." },
      { top: 'Kate', message: 'So...' },
      { top: 'Kate', message: 'Can we get a dog?' },
    ],
  };

  window.adConfigs['six-memories-br-one-unforgettable-birthd'] = {
    headline: 'Six memories. <br> One unforgettable birthday.',
    subtitle: 'Create six personalised chocolate bars <br>that tell your story, one memory at a time.',
    flavour: 'Caramel',
    type: 'date',
    theme: 'relationship',
    pronoun: 'their',
    bars: [
      { top: '07.04.19', message: 'The day we met' },
      { top: '12.08.20', message: 'First holiday together' },
      { top: '18.07.21', message: 'That spontaneous road trip' },
      { top: '09.10.22', message: 'The proposal' },
      { top: '15.06.24', message: 'The best year yet' },
      { top: '14.06.26', message: 'Happy Birthday' },
    ],
  };
})();
